var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal_size" }, [
    _c(
      "a",
      {
        staticClass: "ui_close",
        attrs: { href: "javascript:", type: "button", rel: "modal:close" },
        on: {
          click: function($event) {
            return _vm.$emit("close")
          }
        }
      },
      [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
    ),
    _vm._v(" "),
    _c("dl", { staticClass: "modal_content" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("dd", [
        _c("div", { staticClass: "view_cont" }, [
          _c("div", { staticClass: "grid_wrap" }, [
            _c("div", { staticClass: "grid_total" }, [
              _vm._v(
                "\n                        Total Count\n                        "
              ),
              _c("em", [
                _vm._v(_vm._s(_vm._f("numberFormat")(_vm.resultCount)))
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { attrs: { id: "grid" } },
              [
                _c("toast-grid", {
                  key: _vm.gridKey,
                  attrs: {
                    gridId: "gridNoticeList",
                    data: _vm.gridData,
                    columns: _vm.gridColumns,
                    options: _vm.gridOptions,
                    pageOptions: _vm.gridPageOptions,
                    theme: _vm.gridTheme,
                    isTotalCount: false,
                    click: _vm.onRowClick
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "paginate" },
              [
                _c("sdl-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "total-rows": _vm.resultCount,
                    "per-page": _vm.perPage,
                    align: "center"
                  },
                  on: { change: _vm.onGoToPage }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "btn_wrap topLine" }, [
            _c("div", { staticClass: "btn_right" }, [
              _c(
                "a",
                {
                  staticClass: "btn_white",
                  attrs: { href: "javascript:" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                },
                [_vm._v("Close")]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", { staticClass: "ellipsis maintit" }, [
      _c("i", [_vm._v("Notice")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b96ef27", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b96ef27","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/admin/other/NoticeListPopup.vue
// module id = 49i2
// module chunks = 0